import React from "react";
import '../Common.scss';
import defaultImage from '../../../assets/default.png';
import './DadoTiles.scss';

export default class DadoTiles extends React.Component<any, any>{
    render() {
        const { pageDetails } = this.props;
        const { elevationImage } = pageDetails || {};
        return (
            <React.Fragment>
                <div className="page-image-container">
                    <div className="page-heading">{pageDetails?.name}</div>
                    <div className="image-section-container">
                        <img crossOrigin="anonymous" src={elevationImage ? `${elevationImage}?ver=${new Date().getTime()}` : defaultImage} alt="" className="image-view" />
                    </div>
                </div>
                <div className="tile-table">
                    <div className="scope-table" style={{width:"40%"}}>
                    {["SCOPE","INSTALLMENT"].map(item => 
                        <div className="table-row">
                            <div className="table-cell" style={{fontWeight: "600", width:"40%"}}>
                                {item}
                            </div>
                            <div className="table-cell" style={{width:"60%"}}>
                                <p></p>
                            </div>
                        </div>
                    )}
                    </div>
                    <div className="scope-table" style={{width:"60%"}}>
                    {["TILE DIMENSIONS","TILE COVERAGE","TILE IMAGE"].map(item => 
                        <div className="table-row">
                            <div className={"table-cell"} style={{fontWeight: "600", width:"30%"}}>
                                {item}
                            </div>
                            <div className="table-cell" style={{width:"70%"}}>
                                <p>{item === 'TILE IMAGE' ? <img src={pageDetails['thumbImage']} width="60px"/> : item === 'TILE COVERAGE' ? Math.round(pageDetails['coverageArea']) + " sq ft" : ""}</p>
                            </div>
                        </div>
                    )}
                    </div>
                </div>
                
                
             
            </React.Fragment>

        )
    }

}